import { apiDownload } from '.';

export async function exportGroupResouceCSV() {
  return apiDownload('/group-resource/export');
}
